module.exports = __webpack_public_path__ + "static/img/whitetitle2.56b2ed38.png";